import { render, staticRenderFns } from "./TableCouponType.vue?vue&type=template&id=26d42747&"
import script from "./TableCouponType.vue?vue&type=script&lang=js&"
export * from "./TableCouponType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports